import React from 'react';
import PropTypes from 'prop-types';
import Div100vh from 'react-div-100vh';

// material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

// styles
import styles from './styles';

// assets
import logoDark from 'assets/logo_main_dark.png';
import logo from 'assets/logo_main.png';

class Loading extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    darkMode: PropTypes.bool,
    message: PropTypes.string,
  };

  render() {
    const { classes, message, darkMode } = this.props;

    return (
      <Div100vh>
        <Grid
          container
          className={classes.root}
          alignContent="center"
          alignItems="center"
        >
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <img src={darkMode ? logoDark : logo} style={{ width: 300 }} alt="rhapsody"/>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              textAlign: 'center',
              marginTop: 40,
            }}
          >
            <CircularProgress color="primary" />
            <Typography display="block" variant="caption" style={{ color: 'white' }}>
              {message}
            </Typography>
          </Grid>
        </Grid>
      </Div100vh>
    );
  }
}

export default withStyles(styles)(Loading);
